import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import { formatDateText } from "../CommonFunctions";

export default function CheckoutDialog({
  open,
  onClose,
  tenancyDetails,
  handleCheckout,
  loading = false,
}) {
  const [actualCheckoutDate, setActualCheckoutDate] = useState(
    tenancyDetails.checkout || ""
  );

  const handleConfirm = () => {
    if (!actualCheckoutDate) return;
    handleCheckout(actualCheckoutDate);
  };

  return (
    <Dialog open={open} onClose={loading ? null : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Checkout</DialogTitle>

      <DialogContent dividers>
        <Box>
          <Typography color="error" variant="body" fontWeight={600} mb={2}>
            Are you sure you want to check out this tenant?
          </Typography><br></br>
          
          <Typography variant="body" mb={1}>
            <b>Room:</b> {tenancyDetails.roomid}
          </Typography><br></br>
          
          <Typography variant="body" mb={1}>
            <b>Check-in:</b>{" "}
            {tenancyDetails.checkin ? formatDateText(tenancyDetails.checkin) : "—"}
          </Typography><br></br>
          
          <Typography variant="body" mb={3}>
            <b>Scheduled Checkout:</b>{" "}
            {tenancyDetails.checkout ? formatDateText(tenancyDetails.checkout) : "—"}
          </Typography><br></br>
        </Box>

        {/* Actual Checkout Date Input */}
        <Box mt={2}>
          <TextField
            label="Actual Checkout Date"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={actualCheckoutDate}
            onChange={(e) => setActualCheckoutDate(e.target.value)}
            disabled={loading}
          />
        </Box>

        {/* Info Message */}
        {/* <Box mt={2}>
          <Typography variant="caption" color="text.secondary">
            This will:
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            • Mark tenancy as checked-out
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            • Set room status to vacant (dirty)
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            • Create vacancy tracking record
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            • Create cleaning ticket
          </Typography>
        </Box> */}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={!actualCheckoutDate || loading}
          onClick={handleConfirm}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          {loading ? "Processing..." : "Confirm Checkout"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}